import { 
  FileText, 
  Droplet, 
  Gauge, 
  AlertTriangle, 
  CheckCircle, 
  Wrench, 
  AlertOctagon,
  ClipboardList,
  Fuel
} from "lucide-react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Service type config with icons and colors
export const SERVICE_TYPE_CONFIG = {
  bit_inspection: { label: "B.I.T. Inspection", icon: FileText, color: "#007AFF", bg: "rgba(0, 122, 255, 0.1)" },
  dot_inspection: { label: "D.O.T. Inspection", icon: FileText, color: "#34C759", bg: "rgba(52, 199, 89, 0.1)" },
  oil_change: { label: "Oil Change", icon: Droplet, color: "#FF9500", bg: "rgba(255, 149, 0, 0.1)" },
  mileage_update: { label: "Mileage Update", icon: Gauge, color: "#8E8E93", bg: "rgba(142, 142, 147, 0.1)" },
  issue_reported: { label: "Issue Reported", icon: AlertTriangle, color: "#FF3B30", bg: "rgba(255, 59, 48, 0.1)" },
  issue_repaired: { label: "Issue Repaired", icon: CheckCircle, color: "#34C759", bg: "rgba(52, 199, 89, 0.1)" },
  daily_inspection: { label: "Daily Inspection", icon: ClipboardList, color: "#5856D6", bg: "rgba(88, 86, 214, 0.1)" },
  maintenance: { label: "Maintenance", icon: Wrench, color: "#007AFF", bg: "rgba(0, 122, 255, 0.1)" },
  out_of_service: { label: "Marked Out of Service", icon: AlertOctagon, color: "#FF3B30", bg: "rgba(255, 59, 48, 0.1)" },
  returned_to_service: { label: "Returned to Service", icon: CheckCircle, color: "#34C759", bg: "rgba(52, 199, 89, 0.1)" },
  fuel_report: { label: "Fuel Report", icon: Fuel, color: "#10B981", bg: "rgba(16, 185, 129, 0.1)" },
};

// Repair Request Categories
export const REPAIR_CATEGORIES = [
  "Engine",
  "Emissions / Aftertreatment",
  "Transmission",
  "Driveline",
  "Axles / Differentials",
  "Brakes",
  "Air System",
  "Steering",
  "Suspension",
  "Electrical",
  "Cooling / HVAC",
  "Fuel System",
  "Wheels / Tires",
  "Frame / Chassis",
  "Cab / Body",
  "Safety Systems",
  "Auxiliary / PTO",
  "Other"
];

